import { appRoutes, commonButtonMessages, useWelcomeUserRegistrationPageLogic, welcomeUserRegistrationMessages } from 'azshared';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { AppButton, AppButtonType } from '../../../../components/buttons/app-button';
import { Card, CardSize } from '../../../../components/card/card';
import { AppLink } from '../../../../components/labels/app-link';
import { useGlobalActions, useGoToLoginFromRegistration } from '../../../../hooks/global-actions';
import { useAppSelector } from '../../../../hooks/redux';
import { LoginContainer } from '../../login-container/login-container';
import './welcome-user-registration-page.scss';
import { BannerCookiePolicy } from 'src/components/banner-cookie-policy/banner-cookie-policy';
import { useNavigate } from 'react-router-dom';

export const WelcomeUserRegistrationPage = () => {
  const { formatMessage } = useIntl();
  const goToLoginFromRegistration = useGoToLoginFromRegistration();
  const navigate = useNavigate();
  const { nameUser, surnameUser, selectedOptionUserType } = useAppSelector((state) => state.features.userRegistration);
  const { goAhead } = useWelcomeUserRegistrationPageLogic(useGlobalActions());
  const handleClickGoBack = useCallback(() => {
    if (selectedOptionUserType === 'PG') {
      navigate('/insert-fiscal-code-user-registration');
    } else {
      navigate('/insert-data-user-registration');
    }
  }, [navigate, selectedOptionUserType]);

  return (
    <div>
      <LoginContainer>
        <div className='welcome-user-registration-page'>
          <Card
            title={formatMessage(welcomeUserRegistrationMessages.pageTitle)}
            subtitle={formatMessage(welcomeUserRegistrationMessages.pageSubtitle)}
            back={formatMessage(commonButtonMessages.backLink)}
            clickGoBack={handleClickGoBack}
            sizeVariant={CardSize.MEDIUM}>
            <div className='welcome-text'>
              {formatMessage(welcomeUserRegistrationMessages.textWelcomeUserRegistration, {
                name: nameUser,
                surname: surnameUser
              })}
            </div>
            <div className='button'>
              <AppButton label={formatMessage(commonButtonMessages.continuedButton)} type={AppButtonType.SUBMIT} onClick={goAhead} />
            </div>
            <div className='disclaimer'>
              {formatMessage(commonButtonMessages.linkBackToLogin)}
              <AppLink to={appRoutes.Login} replace={false} label={formatMessage(commonButtonMessages.linkToLogin)} onClick={goToLoginFromRegistration} />
            </div>
          </Card>
        </div>
      </LoginContainer>
      <BannerCookiePolicy />
    </div>
  );
};
